import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Smartphone, Tablet } from "lucide-react";

const IPHONE_ROWS = [
  { model: "iPhone 15 / 15 Pro", screen: "À partir de 179€", battery: "À partir de 95€" },
  { model: "iPhone 14 / 14 Pro", screen: "À partir de 155€", battery: "À partir de 85€" },
  { model: "iPhone 13 / 13 Pro", screen: "À partir de 129€", battery: "À partir de 69€" },
  { model: "iPhone 12 / 12 Pro", screen: "À partir de 109€", battery: "À partir de 65€" },
  { model: "iPhone 11 / XR / XS", screen: "À partir de 95€", battery: "À partir de 59€" },
  { model: "iPhone 8 / SE", screen: "À partir de 69€", battery: "À partir de 55€" },
];

const IPAD_ROWS = [
  { model: 'iPad Pro 12.9"', screen: "À partir de 299€", battery: "À partir de 119€" },
  { model: 'iPad Pro 11"', screen: "À partir de 239€", battery: "À partir de 109€" },
  { model: "iPad Air", screen: "À partir de 205€", battery: "À partir de 95€" },
  { model: "iPad 10 / 9 / 8", screen: "À partir de 155€", battery: "À partir de 85€" },
  { model: "iPad Mini", screen: "À partir de 179€", battery: "À partir de 85€" },
];

const AppleLogo = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.81-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z" />
  </svg>
);

const PricingCard = ({ Icon, title, rows }) => (
  <Card className="overflow-hidden border-2 border-slate-200 shadow-lg">
    <div className="bg-slate-900 text-white p-4 flex items-center gap-3">
      <Icon className="h-6 w-6" />
      <h3 className="font-bold text-lg">{title}</h3>
    </div>
    <CardContent className="p-0">
      <table className="w-full">
        <thead className="bg-slate-100">
          <tr>
            <th scope="col" className="text-left p-3 text-sm font-semibold text-slate-700">Modèle</th>
            <th scope="col" className="text-center p-3 text-sm font-semibold text-slate-700">Écran</th>
            <th scope="col" className="text-center p-3 text-sm font-semibold text-slate-700">Batterie</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((row) => (
            <tr key={row.model} className="border-t border-slate-100 hover:bg-red-50 transition-colors">
              <td className="p-3 font-medium text-slate-900">{row.model}</td>
              <td className="p-3 text-center text-red-600 font-semibold">{row.screen}</td>
              <td className="p-3 text-center text-slate-600">{row.battery}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </CardContent>
  </Card>
);

export const ApplePricingTables = () => (
  <section className="section-padding bg-gradient-to-b from-slate-50 to-white">
    <div className="container-custom">
      <div className="text-center mb-12">
        <Badge className="bg-slate-900 text-white px-4 py-2 mb-4 hover:bg-slate-900">
          <AppleLogo className="w-5 h-5 mr-2" />
          Tarifs iPhone & iPad
        </Badge>
        <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4">Réparation iPhone & iPad</h2>
        <p className="text-lg text-slate-600">Pièces premium • Techniciens certifiés • Garantie 6 mois</p>
      </div>

      <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto">
        <PricingCard Icon={Smartphone} title="iPhone" rows={IPHONE_ROWS} />
        <PricingCard Icon={Tablet} title="iPad" rows={IPAD_ROWS} />
      </div>
    </div>
  </section>
);
